import React from 'react'
import logo from "../../../images/ToppanSecurity.svg";
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { redirectToLogin } from '../../../auth/authProvider';

export default () => {

    let { userstate } = useParams();

    useEffect(() => {

        if (userstate != null && userstate != undefined) {
            redirectToLogin();
        }

    }, [])


    return (
        <div>
            <nav class="navbar navbar-expand-lg navbar-light App-header">
                <div class="container-fluid">
                    <div>
                        <a class="navbar-brand" href="#"><img src={logo} width="104" height="43" alt="Logo"></img></a>
                        <span class='text-black'>goID™ Issuance System Portal</span></div>
                    <div>
                        <button className='primaryButton' onClick={validateLogin}>Login</button>
                    </div>
                </div>

            </nav>
        </div>

    )

    async function validateLogin() {
      await redirectToLogin();
    }

}